import { Injectable, inject } from '@angular/core';
import { ToastService } from './toast.service';

@Injectable()
export class CommonService {
	readonly Toast = inject(ToastService);

	copy(text: string, message?: string) {
		const messageSuccessCopy = message ?? 'Texto copiado!';

		navigator.clipboard.writeText(text).then(
			() => {
				this.Toast.success({
					title: 'Sucesso!',
					message: messageSuccessCopy,
				});
			},
			() => {
				this.Toast.error({
					title: 'Erro!',
					message: 'Erro ao copiar texto, tente novamente.',
				});
			},
		);
	}
}
